import React from 'react'
import { connect } from 'react-redux'
import { Icon, Button } from 'semantic-ui-react'

const styles = {
  marginLeft: 'auto',
  marginBottom: '0.625rem',
  background: 'black',
}

const CameraStatus = ({ cameraIsOnline }) => (
  <Button style={styles} icon labelPosition="left" color="black" circular>
    <Icon
      name="idea"
      style={{ marginRight: '.625rem' }}
      color={cameraIsOnline ? 'green' : 'red'}
    />
    {cameraIsOnline ? 'Камера в сети' : 'Камера вне сети'}
  </Button>
)

const mapStateToProps = ({
  device: {
    currentDevice: {
        camera
    },
  },
}) => ({
    cameraIsOnline: camera?.isOnline || false,
})


export default connect(mapStateToProps)(CameraStatus)
